import { Typography, Stack, Container, Box, Card } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import React, { useEffect, useState } from "react";
import MuiDataTable from "../../components/muidatatable";
import MuiSearch from "../../components/muisearch";
import MuiButton from "../../components/muibutton";
import { getAPI } from "../../services/basehttpAPI";
import { useLocation, useNavigate } from "react-router-dom";
import * as BusinessConst from "../../utils/businessconstants";
import SnackbarComponent from "../../components/snackbar";

const UserList = () => {
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    //always pass id, label, align property
    const columnHeaders = [
        { id: "id", label: "#", align: "left", enableSort: true },
        {
            id: "fullName",
            label: translatedText?.name,
            align: "left",
            enableSort: true,
            style: "bold",
        },
        { id: "email", label: translatedText?.email, align: "left", enableSort: true },
        { id: "isActive", label: translatedText?.status, align: "left", enableSort: true },
        { id: "lastLogin", label: translatedText?.last_login, align: "left", enableSort: true },
        { id: "action", label: translatedText?.action, align: "left", pagekey: BusinessConst.pagekey_userlist, enableSort: false },
    ];
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem("userlist_SearchKeyword") || "");

  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const location = useLocation();

  const getAllApplicationUsers = async () => {
    let url = "ApplicationUser/GetApplicationUserByMarketId";
    const response = await getAPI(url, null);
    setInitialData(response.responseData);
  };

  useEffect(() => {
    getAllApplicationUsers();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (location.state?.Snackbaropen) {
      setseverity("success");
      setmessage("User Deleted successfully");
      setOpen(true);
      navigate({
        state: {
          Snackbaropen: false,
        }
      });
    }
  }, [location.state]);

  useEffect(() => {
    const filteredList = filterData(searchValue);
    setDataList(filteredList);
    sessionStorage.setItem("userlist_SearchKeyword", searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, initialData]);

  const filterData = (searchValue) => {
    if (searchValue === "") {
      return initialData;
    }
    return initialData.filter(
      (d) =>
        d.firstName.toLowerCase().includes(searchValue.toLowerCase()) ||
        d.email.toLowerCase().includes(searchValue.toLowerCase()) ||
        (d.isActive ? "active" : "inactive").includes(searchValue.toLowerCase())
    );
  };

  const handleNavigation = () => {
    navigate("/layout/adduser");
  }
  return dataList?.length > 0 ? (
    <>
      <Container maxWidth="xl" sx={{ width: "100%", ml: "10px" }}>
        <Stack direction="row" spacing={2} paddingBottom={"30px"}>
          <Typography variant="h5" flexGrow={1}>
            {" "}
            Users
          </Typography>
          <MuiButton
                      type="button"
                      text={translatedText.add_user}//"Add User"
            color="success"
            onClick={handleNavigation}
            show={true}
          />
        </Stack>
        <Box>
          <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
          <MuiDataTable headerdata={columnHeaders} rowData={dataList} storageKey="userlist" searchValue={searchValue} />
        </Box>
      </Container>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </>
  ) : (<>
    <Container maxWidth="xl" sx={{ width: "100%", ml: "10px" }}>
      <Stack direction="row" spacing={2} paddingBottom={"30px"}>
        <Typography variant="h5" flexGrow={1}>
          {" "}
          Users
        </Typography>
        <MuiButton
          type="button"
          text={translatedText.add_user}//"Add User"
          color="success"
          onClick={handleNavigation}
          show={true}
        />
      </Stack>
      <Box>
        <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
      </Box>
      <Card>
        <CardContent>
          <Typography variant="h6" align="center" component="div">
                          {translatedText?.no_records_found}
          </Typography>
        </CardContent>
      </Card>
    </Container>
  </>);
};

export default UserList;
